export default __webpack_public_path__ + "static/media/member-dashboard.5c6d7395.svg";